import ManagedIframe from 'utils/ManagedIframe';

const textHtmlPluginLoader = (entryPoint, element) => (
  new ManagedIframe(entryPoint)
    .build()
    .styleToFullscreen()
    .addFullscreenPermission()
    .appendTo(element)
);

const getPluginLoader = (contentType) => ({
  'text/html': textHtmlPluginLoader,
}[contentType]);


export const loadPluginView = (entryPoint, element) => {
  const pluginLoader = getPluginLoader(entryPoint.contentType);
  if (!pluginLoader) {
    throw new Error(`couldn't find appropriate loader for plugin with contentType: ${entryPoint.contentType}`);
  }

  const view = pluginLoader(entryPoint.entryPoint, element);
  if (!view) {
    throw new Error(`couldn't initialize plugin view. entryPoint: ${entryPoint.entryPoint}`);
  }
  return view;
};

export const loadErrorView = (entryPoint, element, errorMessage) => {
  const errorElement = document.createElement('div');
  errorElement.innerHTML = `Error loading plugin @ ${entryPoint.entryPoint}</p> ${errorMessage}`;
  element.appendChild(errorElement);
};
